import BaseAbility from 'umg-ember-backend/abilities/base';

export default class ArtistFunctionRelationAbility extends BaseAbility {
  get permissions() {
    return this.permission.for('category');
  }
}
